























import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {INoticeType} from '@/entities/notices'
import NoticeTypeBadge from './NoticeTypeBadge.vue'

@Component<NoticeTypeRow>({
    components: {NoticeTypeBadge}
})
export default class NoticeTypeRow extends Vue {
    @Prop(Object) public noticeType !: INoticeType
    @Prop(Boolean) public selected !: boolean
}
